import { render, staticRenderFns } from "./rxo.ativacao.vue?vue&type=template&id=37b5e581&"
import script from "./rxo.ativacao.vue?vue&type=script&lang=js&"
export * from "./rxo.ativacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports